export const config = {
  serverURL: "https://0gzwv618g4.execute-api.us-east-1.amazonaws.com/dev/api/v1.0",
  NXTServerURL: "https://{tenant}.dev.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "dev",
  clientId: "5hbbl270qug5682984o1tsm7ms",
  cognitoDomain: "marketron-dev.auth.us-east-1.amazoncognito.com",
  identityProvider: "marketron-dev.com",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-dev.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_s6bRlZd0d",
};
